import PDFDocument from "../index";
import { pdf } from "@react-pdf/renderer";
import { Text, View } from "@react-pdf/renderer";
import { formatNumber } from "./mappings";

export const generateAndDownloadPDF = async (
  headers,
  partidas,
  incrementos,
  detalles,
  contract,
  polinomios,
  variant = "default",
  applicationRoles,
) => {
  const doc = (
    <PDFDocument
      headers={headers}
      partidas={partidas}
      incrementos={incrementos}
      detalles={detalles}
      contract={contract}
      polinomios={polinomios}
      variant={variant}
      applicationRoles={applicationRoles}
    />
  );
  const blob = await pdf(doc).toBlob();

  // Crear link de descarga
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${headers?.contracT_NAME}_EstadoPago_${headers?.nrO_EP}_${headers?.meS_EP}.pdf`;
  link.click();
  URL.revokeObjectURL(url);
};

export const enum_TIPO_RESPUESTA = {
  NINGUNO: 0, //Este no es aceptado en la tabla TIPO_RESPUESTA, solo es usado en el código.
  AEC: 1,
  ATO: 2,
  AAD: 3,
  ADN: 4,
  RFA1: 5,
  RFA2: 6,
  RFA3: 7,
  ICC: 8,
  LCC: 9,
};

export const getNumberSizeStyle = (styles, value, stretch = false) => {
  const n = Number(value);
  if (Number.isNaN(n)) return styles.numberText;

  const abs = Math.abs(n);
  if (abs >= 1_000_000_000)
    return stretch ? styles.numberTextBillionStretch : styles.numberTextBillion;
  if (abs >= 100_000_000)
    return stretch
      ? styles.numberHundredMillionStretch
      : styles.numberHundredMillion;
  if (abs >= 1_000_000)
    return stretch ? styles.numberTextMillionStretch : styles.numberTextMillion;
  return stretch ? styles.numberTextStretch : styles.numberText;
};

export const renderNumberCell = (
  styles,
  value,
  classes,
  textStyle,
  stretch = false,
  min = 0,
  max = 0,
  isMoney = false,
  simple = false,
  formatterFn = formatNumber,
) => (
  <>
    {!simple ? (
      <View style={classes}>
        <Text
          style={[textStyle, getNumberSizeStyle(styles, value, stretch)]}
          wrap={false}
        >
          {formatterFn(value, min, max)}
        </Text>
      </View>
    ) : (
      <>{formatterFn(value, min, max)}</>
    )}
  </>
);
